import { Checkbox } from '@applift/factor'
import { GridSlotsComponent, GridIconSlotsComponent } from '../models'
import { GridFooter, GridHeader } from '../components/slot'
import { GridErrorOverlay } from '../components/GridErrorOverlay'
import { GridNoResultsOverlay } from '../components/GridNoResultsOverlay'
import { GridNoRowsOverlay } from '../components/GridNoRowsOverlay'
import { DataGridColumnHeaders } from '../components/DataGridColumnHeaders'

import {
  GridSeparatorIcon,
  GridArrowDownwardIcon,
  GridArrowUpwardIcon,
  GridUnsortedIcon,
  GridFilterAltIcon,
} from '../components/icons'
import { GridRow } from '../components/GridRow'
import { GridCell } from '../components/cell/GridCell'
import { GridSkeletonCell } from '../components/cell/GridSkeletonCell'
import { GridFooterCell } from '../components/cell/GridFooterCell'

const DEFAULT_GRID_ICON_SLOTS_COMPONENTS: GridIconSlotsComponent = {
  ColumnFilteredIcon: GridFilterAltIcon,
  // Todo replace icon with unsorted icon svg
  ColumnUnsortedIcon: GridUnsortedIcon,
  ColumnSortedAscendingIcon: GridArrowUpwardIcon,
  ColumnSortedDescendingIcon: GridArrowDownwardIcon,
  ColumnResizeIcon: GridSeparatorIcon,
}

export const DATA_GRID_DEFAULT_SLOTS_COMPONENTS: GridSlotsComponent = {
  ...DEFAULT_GRID_ICON_SLOTS_COMPONENTS,
  BaseCheckbox: Checkbox,
  Footer: GridFooter,
  Header: GridHeader,
  NoResultsOverlay: GridNoResultsOverlay,
  NoRowsOverlay: GridNoRowsOverlay,
  ErrorOverlay: GridErrorOverlay,
  Row: GridRow,
  Cell: GridCell,
  SkeletonCell: GridSkeletonCell,
  ColumnFooterCell: GridFooterCell,
  ColumnHeaders: DataGridColumnHeaders,
}
